import { useEffect, useState } from 'react'

const useSessionState = (key: string, initialValue: any) => {
  const [value, setValue] = useState(() => {
    const keyValue = sessionStorage.getItem(key)
    return keyValue ? JSON.parse(keyValue) : initialValue
  })

  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(value))
  }, [key, value])

  return [value, setValue]
}

export default useSessionState
